import {
    rejestrRoutes,
    profileRoutes,
    planHarmRoutes,
    sprawozdaniaRoutes,
    accountRoutes,
} from './index'

import ViewWpHome from "../../components/views/home/wp/ViewWpHome.jsx";

const startRoute = {
    path: '/',
    roles: ['any'],
    exact: true,
    forbidden: true,
    view: <ViewWpHome />,
    mode: 'pass',
}

export const routesWp = [
    startRoute,
    ...accountRoutes,
    ...rejestrRoutes,
    ...profileRoutes,
    ...planHarmRoutes,
    ...sprawozdaniaRoutes,
]
